import { useRef } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { API_URL } from '../../../../utils/constants';
import { CreatedOnCell } from '../../../../components/common/grid/Cells';
import PullFnbOrders from '../components/PullFnbOrders';
import ConsolidateFnbOrders from '../components/ConsolidateFnbOrders';
import GridWrapper from '~/src/components/common/GridWrapper';
import { DateRangeFilterCell } from '~/src/components/common/grid/DateRangeFilterCell';

export default function FnbConsolidationList(): JSX.Element {
  const stateRef = useRef(null);
  const url = `${API_URL}/fnb/get-consolidations`;
  const history = useHistory();
  const StatefullGrid = withState(Grid, url);

  const linkToFnbOrders = (row) => {
    const { dataItem } = row;
    
    return (
      <td>
        <Link to={`/orders/fnb-consolidation-details/${dataItem.id}`}>
          {dataItem.orderNumber} Consolidation View
        </Link>
      </td>
    );
  };

  const linkToOrder = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/orders/details/${dataItem.id}`}>{dataItem.orderNumber} Order View</Link>
      </td>
    );
  };

  const UpdateTable = () => {
    stateRef?.current?.update();
  };

  return (
    <WhitePad isFluid>
      <TitleComponent
        onLeftHandler={(): void => {
          history.push(`/home`);
        }}
        title="Packing FNB Orders"
      />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <PullFnbOrders onUpdate={UpdateTable} />
        <ConsolidateFnbOrders onUpdate={UpdateTable} />
      </div>
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="orderNumber" title="Svila Order" cell={linkToOrder} />
          <GridColumn field="orderNumber" title="Fnb Orders" cell={linkToFnbOrders} />
          <GridColumn field="createdOn" title="Date" cell={CreatedOnCell} filterCell={DateRangeFilterCell}/>
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
